import { Component, inject, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from '@services/configuration/configuration.service';
import { GabaritService } from '@services/gabarit/gabarit.service';
import { ConfigMeta } from 'src/app/models/meta';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';

@Component({
  selector: 'app-planifier-appel',
  templateUrl: './planifier-appel.component.html',
  standalone: false,
})
export class PlanifierAppelComponent implements OnInit {
  @Input() cybermetrieLabel!: string;
  @Input() cybermatrieExtraAttribut!: string;
  private readonly translateService = inject(TranslateService);
  private readonly configService = inject(ConfigurationService);
  private readonly gabaritService = inject(GabaritService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);

  cleTraductionPlanifierAppelMobile = 'lien.planifierAppelPage.mobile';
  cleTraductionPlanifierAppelWeb = 'lien.planifierAppelPage.web';

  pagePlanifierAppelMobile: string = '';
  pagePlanifierAppelWeb: string = '';

  get urlPlanifierAppel(): string {
    const urlRappel = this.configService.getValueOrBlank(ConfigMeta.OEL_URL_PLANIFIER_APPEL);
    if (this.gabaritService.isAppMobile()) {
      return urlRappel ? urlRappel + this.pagePlanifierAppelMobile : '';
    } else {
      return urlRappel ? urlRappel + this.pagePlanifierAppelWeb : '';
    }
  }

  ngOnInit(): void {
    this.translateService
      .get(this.cleTraductionPlanifierAppelMobile)
      .subscribe((texte: string) => (this.pagePlanifierAppelMobile = texte));
    this.translateService
      .get(this.cleTraductionPlanifierAppelWeb)
      .subscribe((texte: string) => (this.pagePlanifierAppelWeb = texte));
  }

  onClickPlanifierAppel() {
    this.cybermetrieCoordonneesService.actionClick(
      this.cybermetrieLabel,
      this.cybermatrieExtraAttribut,
    );
  }
}
